import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import css_248z from './footer-header.scss.js';

class FooterHeader extends s {
    render() {
        return $ `<div class="footer-header"><slot></slot></div>`;
    }
}
FooterHeader.styles = css_248z;
customElements.define('footer-header', FooterHeader);

export { FooterHeader };
